import moment from 'moment';
import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="table-header-subtitle live-report-ctr-description">
                    <div>
                        {this.props.lastUpdatedDate && (
                            <div className="d-flex align-items-center live-report-ctr-description-item">
                                {t('discover.live_optimization.table.last_update')}
                                {moment(this.props.lastUpdatedDate).format('MMM D, YYYY h:mm A')}
                                "pacific time - 6-8 hours lag in GSC"
                            </div>
                        )}
                        <div className="d-flex align-items-center live-report-ctr-description-item">
                            <div className="live-report-ctr-description-header">
                                {t('discover.live_optimization.table.subtitle', {
                                    staticAverageCTR: this.props.staticAverageCTR,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraButtons;
